class ReferenceTest {
    _recycleproc = null;

    _highmap = new Map();
    _lowmap = new Map();

    _highcount = 0;
    _lowcount = 0;

    _buffersize = 36;

    _highobj = null;
    _lowobj = null;

    constructor(buffersize, recycleproc) {
        this._recycleproc = recycleproc
        if (!buffersize) buffersize = Infinity;
        this._buffersize = buffersize;
    }

    sorthighmap(testobj) {
        this._highobj = testobj;
        for (const value of this._highmap.values()) {
            if (value.reftimes < testobj.reftimes) {
                this._highobj = value;
                break;
            }
        }
    }

    test(target) {
        const key = target;
        let testobj = this._highmap.get(key) || this._lowmap.get(key);
        if (!testobj) {
            testobj = {target:target, reftimes:1};
            if (this._highcount < this._buffersize) {
                this._highcount++;
                this._highmap.set(key, testobj);
                if (!this._highobj || this._highobj.reftimes > 1) this._highobj = testobj;
            } else {
                if (this._lowcount >= this._buffersize) {
                    this._lowcount = 1;
                    if (this._recycleproc) {
                        const recycledatas = [];
                        for (const [key, value] of this._lowmap) recycledatas.push(value.target);
                        this._recycleproc(recycledatas);
                    }
                    this._lowmap.clear();
                    this._lowobj = testobj;
                } else {
                    this._lowcount++;
                    if (!this._lowobj || this._lowobj.reftimes == 1) this._lowobj = testobj;
                }
                this._lowmap.set(key, testobj);

            }
        } else {
            var reftimes = ++testobj.reftimes;
            if (testobj == this._highobj) {
                this.sorthighmap(testobj);
            } else {
                if (this._lowmap.get(key) !== undefined) {
                    if (reftimes >= this._highobj.reftimes) {
                        var highkey = this._highobj.target;
                        this._lowobj = this._highobj;
                        this._highmap.set(key, testobj);
                        this._highmap.delete(highkey);
                        this._lowmap.delete(key);
                        this._lowmap.set(highkey, this._lowobj);
                        this.sorthighmap(testobj);
                    } else if (testobj != this._lowobj && reftimes >= this._lowobj.reftimes) {
                        this._lowobj = testobj;
                    }
                }
            }
        }
        return testobj;
    }
}

export default ReferenceTest;